import { phpRequest } from "./phpRequest";

export const getCompanyTokenAPI = async (companyId) => {
  const data = await phpRequest.get("/company-token/get", {
    company_id: companyId,
  });
  return data.token;
};
